<template>
  <v-container fluid class="px-0">
    <v-card class="mb-4" v-if="!loadDefault">
      <v-card-title>
        <v-row no-gutters>
          <v-col cols="4">
            Paieška
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <form @keydown.enter.prevent="submit()">
          <v-row class="mb-0 pb-0">
            <v-col cols="12" md="3">
              <el-text-field
                label="Registracijos numeris"
                v-model="mainData.pra_numeris"
                hide-details
              />
            </v-col>
            <v-col cols="12" md="3">
              <el-text-field
                label="Prašymo numeris"
                v-model="mainData.pra_dokumento_numeris"
                hide-details
              />
            </v-col>
            <v-col cols="12" md="3">
              <el-autocomplete
                :items="prasymas_busena"
                itemvalue="value"
                itemtext="text"
                :multiple="true"
                label="Būsena"
                v-model="mainData.pra_busena"
              />
            </v-col>
            <v-col cols="12" md="3">
              <el-checkbox
                class="mt-3 ml-5"
                label="Mano darbai"
                v-model="mainData.mano_darbai"
              />
            </v-col>
          </v-row>

          <v-expansion-panels
            v-model="searchPanel"
            :class="isExpanded ? `mb-4` : `mb-4 mt-3`"
            :flat="isExpanded"
          >
            <v-expansion-panel>
              <v-expansion-panel-header :class="isExpanded ? `pa-0` : ``">
                <v-row no-gutters>
                  <v-col cols="4">
                    Išplėstinė paieška
                  </v-col>
                </v-row>
              </v-expansion-panel-header>
              <v-expansion-panel-content class="expansion-panel-no-padding">
                <v-row>
                  <v-col cols="12" md="12">
                    <el-autocomplete
                      :items="prasymas_tipas"
                      itemvalue="value"
                      itemtext="text"
                      :multiple="true"
                      label="Prašymo rūšis"
                      v-model="extraData.pra_tipas"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <el-text-field
                      label="Šalies kodas arba pavadinimas"
                      v-model="extraData.salys"
                    />
                  </v-col>
                  <v-col cols="12" md="6">
                    <el-text-field
                      label="Duomenų teikėjas"
                      v-model="extraData.teikejas"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <el-text-field
                      label="Vykdytojas"
                      v-model="extraData.pra_vykdo"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <el-date-picker
                      label="Gavimo data nuo"
                      v-model="extraData.pra_perdavimo_data_nuo"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <el-date-picker
                      label="Gavimo data iki"
                      v-model="extraData.pra_perdavimo_data_iki"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <el-text-field
                      label="Paskutinis veiksmus atlikęs asmuo"
                      v-model="extraData.pra_atnaujino"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <el-date-picker
                      label="Būsenos data nuo"
                      v-model="extraData.pra_busenos_data_nuo"
                    />
                  </v-col>
                  <v-col cols="12" md="4">
                    <el-date-picker
                      label="Būsenos data iki"
                      v-model="extraData.pra_busenos_data_iki"
                    />
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-row no-gutters>
            <v-col cols="12">
              <el-button
                :loading="loading"
                primary
                @click.native.stop="searchData()"
              >
                Ieškoti
              </el-button>
              <el-button :loading="loading" @click.native="clearData()">
                Išvalyti
              </el-button>
            </v-col>
          </v-row>
        </form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import { mapGetters } from 'vuex'
import userRole from '@/mixins/userRole'

export default {
  name: 'ZurnalasNtrGaunamiSearch',
  props: {
    loading: Boolean,
  },
  mixins: [userRole],
  data: () => ({
    searchPanel: null,
    loadDefault: null,
    mainData: {
      mano_darbai: true,
      pra_busena: ['perduotas', 'nepatikslintas'],
    },
    extraData: {},
    prasymas_tipas: [],
    prasymas_busena: [],
  }),
  computed: {
    ...mapGetters(['searchParams', 'listInfo']),
    isExpanded() {
      return this.searchPanel === 0
    },
  },
  inject: {
    $validator: '$validator',
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      this.loadDefault = true

      const data = {
        klasifikatoriai: ['prasymas_tipas', 'prasymas_busena'],
      }

      this.$axios
        .post(`klasifikatorius/list`, data)
        .then(res => {
          this.prasymas_tipas = res.data.list.prasymas_tipas
          this.prasymas_busena = res.data.list.prasymas_busena

          this.mainData.mano_darbai = !this.roleOr(['RG_NTR_vadovas'])

          if (
            this.searchParams &&
            this.searchParams.route === this.$route.name
          ) {
            this.mainData = this.searchParams.mainData
            this.extraData = this.searchParams.extraData
            this.searchPanel = this.searchParams.isExpanded ? 0 : null
          }

          this.searchData()
        })
        .catch(err => {
          window._VMA.$emit('DATA_ERROR', err.response.data.message)
        })
        .finally(() => {
          this.loadDefault = false
        })
    },
    searchData() {
      let searchData = {
        ...this.mainData,
        ...this.extraData,
      }

      if (this.$route.params.toList) {
        searchData = this.listInfo.search
      }

      this.$store.dispatch('searchParams', {
        route: this.$route.name,
        mainData: this.mainData,
        extraData: this.extraData,
        isExpanded: this.isExpanded,
      })

      this.$emit('search', searchData)
    },
    clearData() {
      this.mainData = {}
      this.extraData = {}
    },
    submit() {
      this.searchData()
    },
  },
}
</script>
